import { render } from "./VaIconNotification.vue?vue&type=template&id=400c76ee"
import script from "./VaIconNotification.vue?vue&type=script&lang=js"
export * from "./VaIconNotification.vue?vue&type=script&lang=js"

import "./VaIconNotification.vue?vue&type=style&index=0&id=400c76ee&lang=scss"
script.render = render

export default script